import { Component, Output, EventEmitter, Input } from '@angular/core';
import { PrinterDetail } from 'src/app/entities/offline';
import * as req from 'src/app/entities/request';
import { GetNotMatchingValues, Sort } from 'src/app/supporting/General';
import { KeyValueSet, LocalService, Status } from 'src/service/local.service';
import { OfflineService } from 'src/service/offline.service';
import { PrinterService } from 'src/service/printer.service';

@Component({
  selector: 'app-available-printers',
  templateUrl: './available-printers.component.html',
  styleUrl: './available-printers.component.scss'
})
export class AvailablePrintersComponent {
  @Input() ctryCode: string; @Input() businessId: string; @Input() isOfflineServiceAvailable: boolean | null = null;
  maxBodyHeight = 0;
  @Output() onPreDataRequired = new EventEmitter();
  @Output() onSaved = new EventEmitter();

  addedPrinterNames: string[] = [];
  selectedKeys: string[] = [];
  loadedApiCount = 0;
  printerDetail: PrinterDetail;
  itemsList: KeyValueSet[];

  constructor(public localService: LocalService, private offlineService: OfflineService, private printerService: PrinterService) { }

  ngOnInit() {
    this.onLoad();
  }

  onLoad() {
    this.onLoadPrinters();
  }

  onLoadPrinters() {
    this.loadedApiCount = 0;
    const req = { BusinessId: this.businessId, CountryCode: this.localService.getLoginAsCountryCode() } as req.BusinessDetail;
    this.printerService.getPrinterNames(req).subscribe(result => {
      this.addedPrinterNames = result.map(x => x.PrinterName);
      this.selectedKeys = result.map(x => x.PrinterName);
      this.onSetList();
    });

    this.offlineService.getPrinters(this.businessId).subscribe(result => {
      this.isOfflineServiceAvailable = true;
      this.printerDetail = result;
      this.onSetList();
    }, error => {
      this.isOfflineServiceAvailable = false;
    });
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        this.onLoad();
      } break;
      case 2: {
        this.onSave();
      } break;
    }
  }

  onSetList() {
    this.loadedApiCount++;
    if (this.loadedApiCount == 2) {
      const itemsList = [];
      this.printerDetail.printerNames.forEach(item => {
        itemsList.push({
          key: item,
          value: item,
          s_value: item.toLowerCase(),
          isSelected: this.selectedKeys.includes(item)
        } as KeyValueSet);
      });
      const missedPrinters = GetNotMatchingValues(this.addedPrinterNames, this.printerDetail.printerNames);
      missedPrinters.forEach(missedPrinter => {
        itemsList.push({
          key: missedPrinter,
          value: missedPrinter,
          isSelected: this.selectedKeys.includes(missedPrinter),
          isInActive: true,
          s_value: missedPrinter.toLowerCase()
        } as KeyValueSet);
      });
      this.itemsList = missedPrinters.length > 0 ? Sort(itemsList, true, "value") : itemsList;
    }
  }

  onSave() {
    this.selectedKeys = this.itemsList.filter(x => x.isSelected).map(x => x.key);
    const req = { BusinessId: this.businessId, CountryCode: this.localService.getLoginAsCountryCode(), PrinterNames: this.selectedKeys } as req.PrinterName;
    this.printerService.savePrinterNames(req).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result && result.status == Status.Success) {
        this.onSaved.emit();
      }
    });
  }
}
